export default email => {
  if (process.env.NODE_ENV === 'production') {
    // First Promoter affiliate tracking
    window.$FPROM?.trackSignup({ email });
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'signupSubmission',
    });
  }
};
